/* T-1085 Cat's Atelier wall builder: RULES ENGINE v4 (theme asset, loaded by sections/ca-wall-builder.liquid).
 *
 * v4 (overnight 2026-10-09 S02) = v3 byte-for-byte below PLUS the FROZEN table (planFrozen): one letter per
 * steps x shelves combo = Martin's 2026-10-08 picks (TASKS.md T-1085 note 2026-10-08):
 *   1x2 A, 1x3 A, 2x3 B (falls to A for a 95/100 cm shelf 3), 3x2 A, 3x3 A, 4x2 A, 4x3 A (falls to C, not B,
 *   for a 95/100 cm shelf 3), 5x2 A, 5x3 A (three shelves level at 114 cm, Martin's pick over B); 2x1 zig-zag side;
 *   1 step = zig-zag family; diamond step 4 is NOT stacking; 0 steps allowed, the builder opens on 3 steps.
 * The page draws ONLY planFrozen(); layoutCandidates() stays as the test oracle. Tests:
 * scratchpad/ca-wall-builder/rules-engine/ (ca_rules.test.js = the 39 S03/10-08 tests unchanged, ca_rules.frozen.test.js).
 *
 * v3 = S03's v2 (overnight-2026-10-06, kept byte-for-byte below except the R2b block, which moved into
 * shelfStackErrors() with identical logic so a test can switch it off) PLUS planBySpec()/layoutCandidates():
 * Martin's 2026-10-07 layout spec (TASKS.md T-1085 notes 2026-10-07): STEP COUNT first, shelves placed on it.
 *   2 steps = zig-zag; 1 shelf beside the top step; 2 shelves = top step CENTRED, a shelf either side at equal
 *   distance. 3 steps = zig-zag. 4-5 steps + 1 shelf = zig-zag. 4 steps + 2-3 shelves = DIAMOND. 5 steps +
 *   2-3 shelves = V (lowest step at the bottom, two arms rising diagonally outward). Drawing capped at
 *   5 steps / 3 shelves; the real count stays visible as an overflow ("+1 step").
 *   Where the spec does not fix shelf placement, the engine returns lettered CANDIDATES (A, B, C), never one
 *   assumed. Never-stack R2b covers shelves at any height (Martin YES 2026-10-07).
 * planWall()/planZigzag()/planTwoRoute() stay for S03's tests (unchanged, picture cap 6 there).
 *
 * Supersedes overnight-2026-10-04/S11 prototype/ca_plan.js. What changed and why: SPEC-DELTA.md.
 * Pure functions, no DOM, no network. Works in node (module.exports) and the browser (window.CaRules).
 *
 * Martin's rulings applied (decision page 2026-10-05, TASKS.md T-1085 note 2026-10-06):
 *   s11-1  window products are LEFT OUT: 7 wall shelves + the Cat Wall Step only.
 *   s11-3  felt + platform colour PER STEP (not one shared pair).
 *   s11-4  bundle defaults (T-1048 build spec): cushion Beige, base fabric Beige, wood Natural Beech,
 *          felt Beige, platform Caramel; The Wave dip = Dip Right.
 *   standing  NEVER STACK; floor-climb first (memory feedback_cat_wall_layout_rules, CAT_WALL_MEASUREMENTS.md B-C).
 *
 * Geometry: cm. x = LEFT edge of a piece, wall centre = 0. y = height of the TOP surface above the floor.
 * Every plan item names its route predecessors in `from` (the pieces a cat climbs FROM to reach it), so a
 * branching layout (two routes) is checkable, not only a single ladder-shaped route.
 *
 * Internal calls go through `api.` on purpose: the test file swaps single functions to prove each test can FAIL.
 */
(function (root) {
  'use strict';

  var C = {
    FIRST_STEP_CM: 30,      // T-1048 layouts start the first step at 30 cm
    LAUNCH_MAX_CM: 50,      // CAT_WALL_MEASUREMENTS.md A: low/launch band "up to ~0.5 m"
    GAP_CM: 35,             // default vertical gap, inside the 30-40 band (#223, Martin 2026-10-24; was 28 in the old 20-30 band)
    MIN_GAP_CM: 20,         // floor the headroom shrink may reach (bottom of the 20-30 kitten/older/heavier band)
    MAX_DEFAULT_GAP_CM: 40, // band ceiling: a generated plan never exceeds it (#223; was 30)
    MAX_JUMP_CM: 45,        // fit-adult exception; never drawn, enforced as an absolute cap
    STAGGER_CM: 25,         // step centre-to-centre sideways offset (15-30 band)
    EDGE_GAP_CM: 15,        // shelf near end this far beyond the surface it is reached from (15-30 band)
    MAX_REACH_CM: 30,       // nearest-edge sideways distance between route neighbours (top of the 15-30 band)
    TOP_CAP_CM: 200,        // headroom: ~30 cm under a 2.3-2.4 m ceiling (illustrative)
    STEP_W_CM: 21,          // cat-wall-step "10 x 21 cm (L x W)": wall-facing axis UNVERIFIED, 21 is the conservative value
    PICTURE_CAP_STEPS: 6,   // S03 planWall only (kept so S03's tests run unchanged)
    PICTURE_CAP_SHELVES: 3,
    SPEC_CAP_STEPS: 5,      // 2026-10-07 spec: drawing capped at 5 steps / 3 shelves (planBySpec)
    SPEC_CAP_SHELVES: 3,
    DEFAULT_SHELF_W_CM: 75, // planBySpec(steps, <number>) draws The Wave 75cm, the Starter Climb shelf
    DEFAULT_STEPS: 3        // v4: the builder opens on 3 steps (Martin 2026-10-08: 0 allowed, open on 3 + 'add steps')
  };

  // ---------------------------------------------------------------- catalogue: who is in the builder
  // ca_type exactly as cats-atelier-pdp.liquid:35-42 resolves it: custom.ca_type first, else product type.
  function caType(p) {
    var mf = p.caType && p.caType.value ? p.caType.value : null;
    return String(mf || p.productType || '').trim().toLowerCase();
  }
  function isWindowProduct(p) {
    // s11-1: window-mounted products hang on the window frame, not in the wall route.
    return /^cat-window-/.test(p.handle) || /\bwindow\b/i.test(p.title || '');
  }
  function roleOf(p) {
    var t = api.caType(p);
    if (t === 'cat shelf' || t === 'cat shelf wood') return 'shelf';
    if (t.indexOf('cat step') === 0) return 'step';
    return null; // accessories (replacement covers/mattresses), houses, bundles
  }
  function eligibleProducts(products) {
    return products.filter(function (p) {
      return p.status === 'ACTIVE' && api.roleOf(p) && !api.isWindowProduct(p);
    }).map(function (p) {
      return { handle: p.handle, title: p.title, role: api.roleOf(p), caType: api.caType(p),
               baseFabric: api.caType(p) === 'cat shelf', product: p };
    });
  }

  // ---------------------------------------------------------------- bundle defaults (s11-4)
  // Source: overnight-2026-10-04/S02-ca-bundles-step/T1048/t1048_bundle_build_spec.json "properties" blocks.
  var BUNDLE_DEFAULTS = {
    'Color': 'Beige',              // shelf cushion fabric
    'Wood Finish': 'Natural Beech',
    'Curve Shape': 'Dip Right',    // The Wave (Starter Climb Shelf Dip Direction)
    'Felt Colour': 'Beige',
    'Platform Colour': 'Caramel'
  };
  var PROPERTY_DEFAULTS = { 'Base Fabric': 'Beige' }; // metal-base shelves only, a line-item property
  var BASE_FABRIC_VALUES = ['Grey', 'Beige', 'Cream', 'Dark Grey', 'Chocolate', 'Bottle Green', 'Deep Navy Blue'];

  function defaultOptions(p, sizeWanted) {
    var out = {}, notes = [];
    (p.options || []).forEach(function (o) {
      var want = api.BUNDLE_DEFAULTS[o.name];
      var v = null;
      if (o.name === 'Size') {
        // Playful Curve folds the dip into Size ("75cm - Dip Right"): honour the dip default inside it.
        var pool = sizeWanted ? o.values.filter(function (x) { return x.indexOf(sizeWanted) === 0; }) : o.values;
        if (!pool.length) pool = o.values;
        v = pool.filter(function (x) { return /Dip Right/.test(x); })[0] || pool[0];
      } else if (want && o.values.indexOf(want) > -1) {
        v = want;
      } else {
        v = o.values[0];
        if (want) notes.push(p.handle + ': "' + o.name + '" has no "' + want + '", fell back to "' + v + '"');
      }
      out[o.name] = v;
    });
    return { options: out, notes: notes };
  }
  function resolveVariant(p, options) {
    var hits = p.variants.nodes.filter(function (v) {
      return v.selectedOptions.every(function (so) { return options[so.name] === so.value; });
    });
    return hits.length === 1 ? hits[0] : null; // exactly one or nothing: never guess
  }

  // ---------------------------------------------------------------- builder state, per-step colours (s11-3)
  function newState(eligible, spec) {
    var byHandle = {};
    eligible.forEach(function (e) { byHandle[e.handle] = e; });
    var stepProduct = eligible.filter(function (e) { return e.role === 'step'; })[0];
    var state = { shelves: [], steps: [], notes: [] };
    (spec.shelves || []).forEach(function (s) {
      var e = byHandle[s.handle];
      if (!e || e.role !== 'shelf') throw new Error('not a builder shelf: ' + s.handle);
      var d = api.defaultOptions(e.product, s.size);
      state.notes = state.notes.concat(d.notes);
      var props = e.baseFabric ? Object.assign({}, api.PROPERTY_DEFAULTS) : {};
      state.shelves.push({ handle: e.handle, options: d.options, props: props });
    });
    for (var i = 0; i < (spec.steps | 0); i++) {
      var sd = api.defaultOptions(stepProduct.product).options;
      state.steps.push({ handle: stepProduct.handle, options: sd }); // one entry PER STEP
    }
    return state;
  }
  function setStepColour(state, index, felt, platform) {
    var s = state.steps[index];
    if (!s) throw new Error('no step ' + (index + 1));
    if (felt) s.options['Felt Colour'] = felt;
    if (platform) s.options['Platform Colour'] = platform;
    return state;
  }
  // Basket lines in route order (steps first, then shelves). Identical {variant, properties} merge into one
  // quantity; a step in a different colour is its own line.
  function cartLines(state, eligible) {
    var byHandle = {};
    eligible.forEach(function (e) { byHandle[e.handle] = e; });
    var lines = [], errors = [];
    function add(handle, options, props) {
      var v = api.resolveVariant(byHandle[handle].product, options);
      if (!v) { errors.push('no variant for ' + handle + ' ' + JSON.stringify(options)); return; }
      var key = v.id + '|' + JSON.stringify(props || {});
      var hit = lines.filter(function (l) { return l.key === key; })[0];
      if (hit) hit.quantity += 1;
      else lines.push({ key: key, id: v.id, sku: v.sku, title: byHandle[handle].title, variantTitle: v.title,
                        price: Number(v.price), quantity: 1, properties: props && Object.keys(props).length ? props : undefined });
    }
    state.steps.forEach(function (s) { add(s.handle, s.options); });
    state.shelves.forEach(function (s) {
      var e = byHandle[s.handle];
      add(s.handle, s.options, e.baseFabric ? s.props : undefined);
    });
    var total = lines.reduce(function (t, l) { return t + l.price * l.quantity; }, 0);
    return { lines: lines, total: Math.round(total * 100) / 100, errors: errors };
  }

  // ---------------------------------------------------------------- geometry helpers
  function overlapX(a, b) { return Math.min(a.x + a.w, b.x + b.w) - Math.max(a.x, b.x); }
  // The house never-stack test (dpc-wall-builder.js:692-698 wouldStack): overlap > half the narrower width.
  function stacks(a, b) { return overlapX(a, b) > Math.min(a.w, b.w) / 2; }
  function edgeGap(a, b) { return Math.max(0, -overlapX(a, b)); }
  function r1(n) { return Math.round(n * 10) / 10; }

  // ---------------------------------------------------------------- planners (the three option styles)
  // input: { shelves: [{w, thick?, label?}], steps: n }. Returns {style, gap, items, notes}.
  function stepsZigzag(n, gap, K, items) {
    for (var k = 0; k < n; k++) {
      var cx = (k % 2 === 0 ? -1 : 1) * K.STAGGER_CM / 2;
      items.push({ kind: 'step', key: 'step_' + (k + 1), x: r1(cx - K.STEP_W_CM / 2), w: K.STEP_W_CM,
                   y: K.FIRST_STEP_CM + gap * k, from: k ? ['step_' + k] : ['floor'] });
    }
  }
  function besideOf(prev, w, side, K) {
    return side > 0 ? prev.x + prev.w + K.EDGE_GAP_CM : prev.x - K.EDGE_GAP_CM - w;
  }
  // Style A/B "zigzag": steps zig-zag; shelves climb on, Z-fashion. A new shelf goes to the side OPPOSITE the
  // previous shelf if that clears every shelf already placed, else further out on the same side. A shelf is
  // never placed over another shelf (the generator is stricter than the checker: zero shelf overlap).
  function planZigzag(input, K, gap) {
    var items = [], notes = [];
    var nSteps = input.steps;
    stepsZigzag(nSteps, gap, K, items);
    var y = nSteps ? K.FIRST_STEP_CM + gap * nSteps : 90;
    if (!nSteps) notes.push('no-floor-start');
    var side = nSteps % 2 === 0 ? -1 : 1; // first shelf opposite the last step
    input.shelves.forEach(function (s, i) {
      var prev = items[items.length - 1];
      var x;
      if (!prev) x = -s.w / 2;
      else {
        var shelves = items.filter(function (it) { return it.kind === 'shelf'; });
        var tries = [side, -side];
        x = null;
        for (var t = 0; t < tries.length && x === null; t++) {
          var cand = besideOf(prev, s.w, tries[t], K);
          var probe = { x: cand, w: s.w };
          if (shelves.every(function (o) { return overlapX(o, probe) <= 0; })) { x = cand; side = tries[t]; }
        }
        if (x === null) { x = besideOf(prev, s.w, side, K); notes.push('shelf-placement-forced'); }
      }
      items.push({ kind: 'shelf', key: 'shelf_' + (i + 1), label: s.label, thick: s.thick, x: r1(x), w: s.w, y: y,
                   from: prev ? [prev.key] : ['floor'] });
      y += gap;
      side = -side;
    });
    return { items: items, notes: notes };
  }
  // Style C "two-route": step 1 centred; the remaining steps form two arms rising outwards (left, right,
  // left...); shelf 1 beyond the left arm, shelf 2 beyond the right arm; shelf 3 centred above, reached from
  // the higher inner end. With fewer than 2 shelves or 3 steps there is no second route: falls back to zigzag.
  function planTwoRoute(input, K, gap) {
    if (input.shelves.length < 2 || input.steps < 3) {
      // a second route needs its own step on each arm (step 1 + one per arm) and a shelf at each end
      var z = planZigzag(input, K, gap);
      z.notes.push('two-route-needs-2-shelves-and-3-steps: drew zigzag');
      return z;
    }
    var items = [], notes = [];
    items.push({ kind: 'step', key: 'step_1', x: r1(-K.STEP_W_CM / 2), w: K.STEP_W_CM, y: K.FIRST_STEP_CM, from: ['floor'] });
    var arms = { '-1': [items[0]], '1': [items[0]] };
    for (var k = 2; k <= input.steps; k++) {
      var side = k % 2 === 0 ? -1 : 1;
      var arm = arms[String(side)];
      var prev = arm[arm.length - 1];
      var level = arm.length; // steps already on this arm incl. the shared step 1
      var cx = side * K.STAGGER_CM * level;
      var st = { kind: 'step', key: 'step_' + k, x: r1(cx - K.STEP_W_CM / 2), w: K.STEP_W_CM,
                 y: K.FIRST_STEP_CM + gap * level, from: [prev.key] };
      items.push(st); arm.push(st);
    }
    var tops = [];
    [-1, 1].forEach(function (side, i) {
      var s = input.shelves[i];
      var arm = arms[String(side)];
      var prev = arm[arm.length - 1];
      var sh = { kind: 'shelf', key: 'shelf_' + (i + 1), label: s.label, thick: s.thick, w: s.w,
                 x: r1(besideOf(prev, s.w, side, K)), y: prev.y + gap, from: [prev.key] };
      items.push(sh); tops.push(sh);
    });
    if (input.shelves[2]) {
      var s3 = input.shelves[2];
      var hi = tops[0].y >= tops[1].y ? tops[0] : tops[1];
      var lo = hi === tops[0] ? tops[1] : tops[0];
      // Shelf 3 between the two inner ends: centred if that is within reach of the higher shelf, else
      // EDGE_GAP beyond the higher shelf's inner end. Zero overlap with either shelf; if neither fits,
      // it goes outboard beyond the higher shelf's far end (noted).
      var inward = hi === tops[0] ? 1 : -1;
      var cands = [-s3.w / 2, besideOf(hi, s3.w, inward, K)];
      var x3 = null;
      for (var c = 0; c < cands.length && x3 === null; c++) {
        var pr = { x: cands[c], w: s3.w };
        if (overlapX(pr, tops[0]) <= 0 && overlapX(pr, tops[1]) <= 0 && edgeGap(hi, pr) <= K.MAX_REACH_CM) x3 = cands[c];
      }
      if (x3 === null) { x3 = besideOf(hi, s3.w, -inward, K); notes.push('shelf-3-outboard'); }
      var probe3 = { x: x3, w: s3.w };
      var from = tops.filter(function (t) { return t.y === hi.y && edgeGap(t, probe3) <= K.MAX_REACH_CM; })
                     .map(function (t) { return t.key; });
      items.push({ kind: 'shelf', key: 'shelf_3', label: s3.label, thick: s3.thick, w: s3.w, x: r1(x3),
                   y: hi.y + gap, from: from });
    }
    return { items: items, notes: notes };
  }

  function planWall(input, style, constants) {
    var K = Object.assign({}, C, constants || {});
    var shelves = (input.shelves || []).slice(0, K.PICTURE_CAP_SHELVES);
    var nSteps = Math.max(0, Math.min(K.PICTURE_CAP_STEPS, input.steps | 0));
    var notes = [];
    if (!shelves.length && !nSteps) return { style: style, items: [], gap: K.GAP_CM, notes: ['empty'] };
    var planner = style === 'two-route' ? api.planTwoRoute : api.planZigzag;
    // Gap: the default; shrink one cm at a time (never below the band floor) while anything breaks headroom.
    var gap = K.GAP_CM, res;
    for (;;) {
      res = planner({ shelves: shelves, steps: nSteps }, K, gap);
      var top = Math.max.apply(null, res.items.map(function (i) { return i.y; }));
      if (top <= K.TOP_CAP_CM || gap <= K.MIN_GAP_CM) break;
      gap -= 1;
    }
    notes = notes.concat(res.notes);
    if ((input.steps | 0) > nSteps) notes.push('steps-not-all-pictured');
    if ((input.shelves || []).length > shelves.length) notes.push('shelves-not-all-pictured');
    return { style: style, items: res.items, gap: gap, notes: notes };
  }

  // ---------------------------------------------------------------- the checker (every drawn plan must pass)
  // Works on ANY plan, generated or hand-written, so a frozen table or a hand-drawn option is held to the
  // same rules as the generator.
  function checkLayout(plan, constants) {
    var K = Object.assign({}, C, constants || {});
    var errs = [];
    var it = plan.items || [];
    var byKey = {};
    it.forEach(function (p) { byKey[p.key] = p; });
    var steps = it.filter(function (p) { return p.kind === 'step'; });
    var shelves = it.filter(function (p) { return p.kind === 'shelf'; });

    // R1 floor-climb first: with any step, the route starts from the floor in the launch band, and every
    // piece is reachable from the floor along `from` links.
    if (steps.length) {
      var starts = it.filter(function (p) { return (p.from || []).indexOf('floor') > -1; });
      if (!starts.length) errs.push('R1 no piece starts from the floor');
      starts.forEach(function (p) {
        if (p.kind !== 'step') errs.push('R1 ' + p.key + ' starts the climb but is not a step');
        if (p.y > K.LAUNCH_MAX_CM) errs.push('R1 ' + p.key + ' floor start at ' + p.y + ' > ' + K.LAUNCH_MAX_CM);
      });
      var seen = {}, queue = starts.map(function (p) { return p.key; });
      while (queue.length) {
        var k = queue.shift();
        if (seen[k]) continue;
        seen[k] = true;
        it.forEach(function (p) { if ((p.from || []).indexOf(k) > -1) queue.push(p.key); });
      }
      it.forEach(function (p) { if (!seen[p.key]) errs.push('R1 ' + p.key + ' not reachable from the floor'); });
    }

    // Route edges: R2a never stacked on the piece it is climbed from; R3 gap band; R4 sideways reach.
    it.forEach(function (b) {
      (b.from || []).forEach(function (fk) {
        if (fk === 'floor') return;
        var a = byKey[fk];
        if (!a) { errs.push('R1 ' + b.key + ' climbs from unknown ' + fk); return; }
        var dy = b.y - a.y;
        if (api.stacks(a, b)) errs.push('R2 ' + b.key + ' stacked ' + (dy === 0 ? 'into' : 'directly above') + ' ' + a.key);
        if (dy > K.MAX_JUMP_CM) errs.push('R3 ' + a.key + '->' + b.key + ' gap ' + dy + ' > max jump ' + K.MAX_JUMP_CM);
        else if (dy > K.MAX_DEFAULT_GAP_CM) errs.push('R3 ' + a.key + '->' + b.key + ' gap ' + dy + ' > ' + K.MAX_DEFAULT_GAP_CM);
        if (dy !== 0 && Math.abs(dy) < K.MIN_GAP_CM) errs.push('R3 ' + a.key + '->' + b.key + ' gap ' + dy + ' < ' + K.MIN_GAP_CM);
        if (edgeGap(a, b) > K.MAX_REACH_CM) errs.push('R4 ' + a.key + '->' + b.key + ' sideways ' + edgeGap(a, b) + ' > ' + K.MAX_REACH_CM);
      });
    });

    // R2b never stack one SHELF directly above another, at ANY height, route neighbours or not.
    errs = errs.concat(api.shelfStackErrors(shelves));
    // Pieces must not physically collide (any two pieces at the same height overlapping).
    for (var p = 0; p < it.length; p++) {
      for (var q = p + 1; q < it.length; q++) {
        if (it[p].kind === 'shelf' && it[q].kind === 'shelf') continue; // covered above
        if (it[p].y === it[q].y && overlapX(it[p], it[q]) > 0) errs.push('R2 ' + it[p].key + ' and ' + it[q].key + ' collide');
      }
    }
    // R5 headroom
    it.forEach(function (pc) { if (pc.y > K.TOP_CAP_CM) errs.push('R5 ' + pc.key + ' at ' + pc.y + ' > headroom cap ' + K.TOP_CAP_CM); });
    return errs;
  }

  // R2b as its own function (same logic S03 had inline in checkLayout).
  function shelfStackErrors(shelves) {
    var errs = [];
    for (var i = 0; i < shelves.length; i++) {
      for (var j = i + 1; j < shelves.length; j++) {
        var a = shelves[i], b = shelves[j];
        if (a.y !== b.y && api.stacks(a, b)) {
          var lo = a.y < b.y ? a : b, hi = lo === a ? b : a;
          errs.push('R2 shelf ' + hi.key + ' stacked above shelf ' + lo.key);
        }
        if (a.y === b.y && overlapX(a, b) > 0) errs.push('R2 ' + a.key + ' and ' + b.key + ' collide at one level');
      }
    }
    return errs;
  }

  // ================================================================ v3: Martin's 2026-10-07 layout spec
  function cxOf(p) { return p.x + p.w / 2; }
  function mkStep(K, key, cx, y, from) {
    return { kind: 'step', key: key, x: r1(cx - K.STEP_W_CM / 2), w: K.STEP_W_CM, y: y, from: from };
  }
  function mkShelf(s, key, x, y, from) {
    return { kind: 'shelf', key: key, label: s.label, thick: s.thick, w: s.w, x: r1(x), y: y, from: from };
  }

  // Which step pattern the spec prescribes (steps/shelves already capped).
  function specStyle(steps, shelves) {
    if (steps <= 0) return 'shelves-only';                 // spec silent: QUESTIONS e
    if (steps === 1) return 'single';                      // spec silent: QUESTIONS b
    if (steps <= 3) return 'zigzag';                       // "2 steps = zig-zag", "3 steps = zig-zag"
    if (steps === 4) return shelves >= 2 ? 'diamond' : 'zigzag';
    return shelves >= 2 ? 'v' : 'zigzag';                  // 5 steps
  }

  // ---- step patterns
  function stepsFor(style, n, K, gap) {
    var items = [];
    if (style === 'single') items.push(mkStep(K, 'step_1', 0, K.FIRST_STEP_CM, ['floor']));
    else if (style === 'diamond') items = api.stepsDiamond(K, gap);
    else if (style === 'v') items = api.stepsV(K, gap);
    else if (style === 'zigzag') api.stepsZigzag(n, gap, K, items);
    return items;
  }
  // Diamond (4 steps): step 1 bottom centre; steps 2 + 3 level, either side; step 4 top centre, reached from 2 or 3.
  function stepsDiamond(K, gap) {
    var F = K.FIRST_STEP_CM, S = K.STAGGER_CM;
    return [mkStep(K, 'step_1', 0, F, ['floor']),
            mkStep(K, 'step_2', -S, F + gap, ['step_1']),
            mkStep(K, 'step_3', S, F + gap, ['step_1']),
            mkStep(K, 'step_4', 0, F + 2 * gap, ['step_2', 'step_3'])];
  }
  // V (5 steps): step 1 = the lowest, at the bottom centre; two arms (2,4 left; 3,5 right) rise diagonally OUTWARD.
  function stepsV(K, gap) {
    var F = K.FIRST_STEP_CM, S = K.STAGGER_CM;
    return [mkStep(K, 'step_1', 0, F, ['floor']),
            mkStep(K, 'step_2', -S, F + gap, ['step_1']),
            mkStep(K, 'step_3', S, F + gap, ['step_1']),
            mkStep(K, 'step_4', -2 * S, F + 2 * gap, ['step_2']),
            mkStep(K, 'step_5', 2 * S, F + 2 * gap, ['step_3'])];
  }

  // ---- shelf placements. Each returns {items:[shelves], notes} or {infeasible: reason}.
  // Zig-zag continuation from `top` (S03 rule: opposite side first, else further out; zero shelf overlap).
  function placeZigzag(top, shelves, K, gap, side, placedAll) {
    var out = [], notes = [], prev = top;
    shelves.forEach(function (s, i) {
      var tries = [side, -side], x = null;
      for (var t = 0; t < tries.length && x === null; t++) {
        var probe = { x: besideOf(prev, s.w, tries[t], K), w: s.w };
        if (out.every(function (o) { return overlapX(o, probe) <= 0; })) { x = probe.x; side = tries[t]; }
      }
      if (x === null) { x = besideOf(prev, s.w, side, K); notes.push('shelf-placement-forced'); }
      var sh = mkShelf(s, 'shelf_' + (i + 1), x, prev.y + gap, [prev.key]);
      out.push(sh); prev = sh; side = -side;
    });
    return { items: out, notes: notes };
  }
  // Centred pair: a shelf either side of `top`, same height (one gap above), at EQUAL edge distance e.
  function placePair(top, sL, sR, K, gap, e) {
    var L = mkShelf(sL, 'shelf_1', top.x - e - sL.w, top.y + gap, [top.key]);
    var R = mkShelf(sR, 'shelf_2', top.x + top.w + e, top.y + gap, [top.key]);
    return [L, R];
  }
  // Pair pushed out just far enough that a third shelf centred over `top` overlaps neither (zero overlap).
  function pairPushFor(s3, top, K) { return Math.max(K.EDGE_GAP_CM, s3.w / 2 - top.w / 2); }
  function centreAbove(top, s, key, y, fromPieces, K) {
    var sh = mkShelf(s, key, cxOf(top) - s.w / 2, y, []);
    sh.from = fromPieces.filter(function (p) { return edgeGap(p, sh) <= K.MAX_REACH_CM && !api.stacks(p, sh); })
                        .map(function (p) { return p.key; });
    return sh;
  }
  function outward(prev, s, side, key, K, gap) {
    return mkShelf(s, key, besideOf(prev, s.w, side, K), prev.y + gap, [prev.key]);
  }

  // Placement recipes by name. ctx = {steps:[items], top, shelves:[geo], K, gap, zigSide}
  var PLACEMENTS = {
    'none': function () { return { items: [] }; },
    'zigzag': function (c) { return placeZigzag(c.top, c.shelves, c.K, c.gap, c.zigSide); },
    'pair': function (c) {
      return { items: api.placePair(c.top, c.shelves[0], c.shelves[1], c.K, c.gap, c.K.EDGE_GAP_CM) };
    },
    'pair+out': function (c) {
      var p = api.placePair(c.top, c.shelves[0], c.shelves[1], c.K, c.gap, c.K.EDGE_GAP_CM);
      return { items: p.concat([outward(p[1], c.shelves[2], 1, 'shelf_3', c.K, c.gap)]) };
    },
    'pair+centre': function (c) {
      var e = pairPushFor(c.shelves[2], c.top, c.K);
      if (e > c.K.MAX_REACH_CM) return { infeasible: 'a ' + c.shelves[2].w + ' cm shelf centred on top needs the pair ' + r1(e) + ' cm from the step (> ' + c.K.MAX_REACH_CM + ' cm reach)' };
      var p = api.placePair(c.top, c.shelves[0], c.shelves[1], c.K, c.gap, e);
      return { items: p.concat([centreAbove(c.top, c.shelves[2], 'shelf_3', p[0].y + c.gap, p, c.K)]),
               notes: e > c.K.EDGE_GAP_CM ? ['pair pushed to ' + r1(e) + ' cm so shelf 3 clears both'] : [] };
    },
    // diamond: a shelf beyond each middle step, level with the top step
    'wings': function (c) {
      var s2 = c.steps[1], s3 = c.steps[2];
      return { items: [outward(s2, c.shelves[0], -1, 'shelf_1', c.K, c.gap), outward(s3, c.shelves[1], 1, 'shelf_2', c.K, c.gap)] };
    },
    'wings+centre': function (c) {
      var w = PLACEMENTS.wings(c).items;
      var sh = centreAbove(c.top, c.shelves[2], 'shelf_3', w[0].y + c.gap, w, c.K);
      return { items: w.concat([sh]), notes: ['shelf 3 is ' + c.gap + ' cm over step 4 (not climbed from it)'] };
    },
    // V: a shelf beyond the top of each arm
    'arms': function (c) {
      var a = c.steps[3], b = c.steps[4];
      return { items: [outward(a, c.shelves[0], -1, 'shelf_1', c.K, c.gap), outward(b, c.shelves[1], 1, 'shelf_2', c.K, c.gap)] };
    },
    'bridge+out': function (c) {
      var a = c.steps[3], b = c.steps[4];
      var br = centreAbove(c.steps[0], c.shelves[0], 'shelf_1', a.y + c.gap, [a, b], c.K);
      return { items: [br, outward(a, c.shelves[1], -1, 'shelf_2', c.K, c.gap)] };
    },
    'arms+bridge': function (c) {
      var arms = PLACEMENTS.arms(c).items;
      var br = centreAbove(c.steps[0], c.shelves[2], 'shelf_3', arms[0].y, [c.steps[3], c.steps[4]], c.K);
      return { items: arms.concat([br]) };
    },
    'arms+inward': function (c) {
      var arms = PLACEMENTS.arms(c).items;
      return { items: arms.concat([outward(arms[0], c.shelves[2], 1, 'shelf_3', c.K, c.gap)]) };
    }
  };

  // The candidate table. specFixed = the 10-07 spec fixes the placement; otherwise the letters are for Martin.
  function candidateDefs(steps, nShelves) {
    var style = api.specStyle(steps, nShelves);
    var d, fixed = false;
    if (nShelves === 0) d = ['none'];
    else if (style === 'shelves-only') d = ['zigzag'];
    else if (style === 'single') d = nShelves === 1 ? ['zigzag'] : nShelves === 2 ? ['zigzag', 'pair'] : ['zigzag', 'pair+out', 'pair+centre'];
    else if (style === 'zigzag' && steps === 2) {
      if (nShelves === 1) { d = ['zigzag']; fixed = true; }          // "1 shelf beside the top step"
      else if (nShelves === 2) { d = ['pair']; fixed = true; }       // "top step centred, a shelf either side"
      else d = ['pair+out', 'pair+centre'];                          // QUESTIONS d
    } else if (style === 'zigzag') {
      if (nShelves === 1) { d = ['zigzag']; fixed = true; }          // 3 steps / 4-5 steps + 1 shelf
      else d = nShelves === 2 ? ['zigzag', 'pair'] : ['zigzag', 'pair+out', 'pair+centre'];
    } else if (style === 'diamond') d = nShelves === 2 ? ['pair', 'wings', 'zigzag'] : ['pair+centre', 'wings+centre', 'zigzag'];
    else d = nShelves === 2 ? ['arms', 'bridge+out'] : ['arms+bridge', 'arms+inward'];
    return { style: style, specFixed: fixed, placements: d };
  }

  function normShelves(shelves, K) {
    if (typeof shelves === 'number') {
      var a = [];
      for (var i = 0; i < shelves; i++) a.push({ w: K.DEFAULT_SHELF_W_CM, thick: 4 });
      return a;
    }
    return (shelves || []).slice();
  }
  function overflowOf(steps, shelves, K) {
    var o = { steps: Math.max(0, steps - K.SPEC_CAP_STEPS), shelves: Math.max(0, shelves - K.SPEC_CAP_SHELVES) };
    var bits = [];
    if (o.steps) bits.push('+' + o.steps + ' step' + (o.steps > 1 ? 's' : ''));
    if (o.shelves) bits.push('+' + o.shelves + (o.shelves > 1 ? ' shelves' : ' shelf'));
    o.label = bits.join(', ');
    return o;
  }
  var LETTERS = 'ABC';
  // Every candidate layout for (steps, shelves). Each: {letter, style, placement, items, gap, notes, errors, feasible}.
  function layoutCandidates(steps, shelves, constants) {
    var K = Object.assign({}, C, constants || {});
    var all = api.normShelves(shelves, K);
    var nStepsReal = Math.max(0, steps | 0);
    var drawSteps = Math.min(K.SPEC_CAP_STEPS, nStepsReal);
    var drawn = all.slice(0, K.SPEC_CAP_SHELVES);
    var defs = api.candidateDefs(drawSteps, drawn.length);
    var overflow = api.overflowOf(nStepsReal, all.length, K);
    var out = defs.placements.map(function (pl, idx) {
      var gap = K.GAP_CM, res, items, stepItems;
      for (;;) {
        stepItems = stepsFor(defs.style, drawSteps, K, gap);
        var top = stepItems[stepItems.length - 1];
        var zigSide = defs.style === 'zigzag' ? (cxOf(top) > 0 ? -1 : 1) : (defs.style === 'single' ? 1 : -1);
        if (defs.style === 'shelves-only') {
          res = planZigzag({ shelves: drawn, steps: 0 }, K, gap);   // S03 behaviour: no floor start, noted
          items = res.items;
        } else {
          res = PLACEMENTS[pl]({ steps: stepItems, top: top, shelves: drawn, K: K, gap: gap, zigSide: zigSide });
          items = res.infeasible ? stepItems : stepItems.concat(res.items);
        }
        var h = Math.max.apply(null, items.map(function (i) { return i.y; }).concat([0]));
        if (h <= K.TOP_CAP_CM || gap <= K.MIN_GAP_CM) break;
        gap -= 1;
      }
      var plan = { letter: LETTERS[idx], style: defs.style, placement: pl, specFixed: defs.specFixed,
                   items: res.infeasible ? [] : items, gap: gap, notes: (res.notes || []).slice(),
                   feasible: !res.infeasible, overflow: overflow,
                   drawn: { steps: drawSteps, shelves: drawn.length } };
      if (res.infeasible) plan.notes.push('not possible: ' + res.infeasible);
      plan.errors = plan.feasible ? api.checkLayout(plan, K) : [];
      return plan;
    });
    return out;
  }
  // The 10-07 entry point. letter picks a candidate (default: the first feasible one).
  function planBySpec(steps, shelves, opts) {
    opts = opts || {};
    var c = api.layoutCandidates(steps, shelves, opts.constants);
    var pick = c.filter(function (p) { return p.feasible && (!opts.letter || p.letter === opts.letter); })[0] || null;
    if (!pick) return null;
    return Object.assign({}, pick, { candidates: c.map(function (p) { return p.letter + (p.feasible ? '' : '(not possible)'); }) });
  }

  // ================================================================ v4: the FROZEN picks (Martin 2026-10-08)
  // key = drawn steps x drawn shelves (both capped at 5 / 3). fallback = the letter to draw when `letter` is not
  // possible for these widths (only the "pair + shelf 3 centred on top" letters can be: SPEC-DELTA-2 E8).
  var FROZEN = {
    '0x1': { letter: 'A' }, '0x2': { letter: 'A' }, '0x3': { letter: 'A' },
    '1x0': { letter: 'A' }, '1x1': { letter: 'A' }, '1x2': { letter: 'A' }, '1x3': { letter: 'A' },
    '2x0': { letter: 'A' }, '2x1': { letter: 'A' }, '2x2': { letter: 'A' }, '2x3': { letter: 'B', fallback: 'A' },
    '3x0': { letter: 'A' }, '3x1': { letter: 'A' }, '3x2': { letter: 'A' }, '3x3': { letter: 'A' },
    '4x0': { letter: 'A' }, '4x1': { letter: 'A' }, '4x2': { letter: 'A' }, '4x3': { letter: 'A', fallback: 'C' },
    '5x0': { letter: 'A' }, '5x1': { letter: 'A' }, '5x2': { letter: 'A' }, '5x3': { letter: 'A' }
  };
  function familyOf(style) {
    if (style === 'single' || style === 'zigzag') return 'zigzag';   // Martin 10-08: 1 step = zig-zag family
    return style;                                                    // diamond | v | shelves-only
  }
  // The named fallback, and nothing else: a fallback is a decision, so "the next feasible letter" is never used.
  function pickFallback(cands, entry) {
    if (!entry.fallback) return null;
    return cands.filter(function (p) { return p.feasible && p.letter === entry.fallback; })[0] || null;
  }
  function planFrozen(steps, shelves, opts) {
    opts = opts || {};
    var K = Object.assign({}, C, opts.constants || {});
    var c = api.layoutCandidates(steps, shelves, opts.constants);
    if (!c.length) return null;
    var key = c[0].drawn.steps + 'x' + c[0].drawn.shelves;
    if (key === '0x0') return null;                                   // an empty build draws nothing
    var entry = api.FROZEN[key];
    if (!entry) return null;
    var pick = c.filter(function (p) { return p.feasible && p.letter === entry.letter; })[0] || null;
    var fellBack = false;
    if (!pick) { pick = api.pickFallback(c, entry); fellBack = !!pick; }
    if (!pick) return null;
    var frozen = { key: key, letter: entry.letter, fallback: entry.fallback || null, used: pick.letter, fellBack: fellBack };
    if (fellBack) pick.notes = pick.notes.concat(['fell back ' + entry.letter + ' -> ' + pick.letter + ' (shelf 3 too wide for ' + entry.letter + ')']);
    return Object.assign({}, pick, { family: familyOf(pick.style), frozen: frozen, defaultSteps: K.DEFAULT_STEPS,
                                     candidates: c.map(function (p) { return p.letter + (p.feasible ? '' : '(not possible)'); }) });
  }
  // The landing state: The Wave 75cm (the Starter Climb shelf, T-1048) + DEFAULT_STEPS steps.
  function defaultBuild() {
    return { shelves: [{ handle: 'cat-wall-shelf-the-wave', size: '75cm' }], steps: C.DEFAULT_STEPS };
  }

  function footprint(plan) {
    var it = plan.items;
    if (!it.length) return { width: 0, left: 0, right: 0, top: 0 };
    var l = Math.min.apply(null, it.map(function (p) { return p.x; }));
    var r = Math.max.apply(null, it.map(function (p) { return p.x + p.w; }));
    return { left: l, right: r, width: r1(r - l), top: Math.max.apply(null, it.map(function (p) { return p.y; })) };
  }

  var api = {
    CONSTANTS: C, BUNDLE_DEFAULTS: BUNDLE_DEFAULTS, PROPERTY_DEFAULTS: PROPERTY_DEFAULTS, BASE_FABRIC_VALUES: BASE_FABRIC_VALUES,
    caType: caType, isWindowProduct: isWindowProduct, roleOf: roleOf, eligibleProducts: eligibleProducts,
    defaultOptions: defaultOptions, resolveVariant: resolveVariant,
    newState: newState, setStepColour: setStepColour, cartLines: cartLines,
    overlapX: overlapX, stacks: stacks, edgeGap: edgeGap,
    planZigzag: planZigzag, planTwoRoute: planTwoRoute, planWall: planWall,
    checkLayout: checkLayout, footprint: footprint,
    // v3
    shelfStackErrors: shelfStackErrors, specStyle: specStyle, stepsZigzag: stepsZigzag, placePair: placePair, stepsDiamond: stepsDiamond, stepsV: stepsV,
    PLACEMENTS: PLACEMENTS, candidateDefs: candidateDefs, normShelves: normShelves, overflowOf: overflowOf,
    layoutCandidates: layoutCandidates, planBySpec: planBySpec,
    // v4
    FROZEN: FROZEN, familyOf: familyOf, pickFallback: pickFallback, planFrozen: planFrozen, defaultBuild: defaultBuild
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = api; else root.CaRules = api;
})(this);
